import {action, computed} from '@api'
import {CatalogStore} from '@stores'
import {CatalogInstanceChildStore} from './CatalogInstanceChildStore'

export class CatalogPresentationStore extends CatalogInstanceChildStore {
  constructor(public catalog: CatalogStore) {
    super(catalog)
  }

  get settings() {
    return this.catalog.settings.presentation
  }

  @computed get visible() {
    return this.settings?.show === true
  }

  @action togglePresentationMode = () => {
    const {settings} = this
    settings.show = settings.show !== true
  }
}


// WEBPACK FOOTER //
// ./src/stores/catalog/CatalogPresentationStore.ts